import React, {
  useEffect,
  useState
} from "react";

import {
  Box,
  Typography,
  Paper,
  Skeleton
} from "@mui/material";


import ReportCard from "../components/reports/ReportCard";


import TicketStatusChart from "../components/reports/TicketStatusChart";
import PriorityChart from "../components/reports/PriorityChart";
import ResolutionTimeChart from "../components/reports/ResolutionTimeChart";
import CategoryReport from "../components/reports/CategoryReport";
import MonthlyTrendChart from "../components/reports/MonthlyTrendChart";
import SLAReport from "../components/reports/SLAReport";
import RecentTickets from "../components/reports/RecentTickets";


import {
  getDashboardSummary
} from "../services/dashboardService";
import { useUserRole } from "../context/UserRoleContext";
import { USER_ROLES } from "../auth/roles";




function Reports() {


  const [loading, setLoading] = useState(true);


  const [dashboard, setDashboard] = useState(null);


  const { role, employee, loading: roleLoading } = useUserRole();


  useEffect(() => {

    if (roleLoading) {
      return;
    }

    const loadSummary = async () => {

      try {

        const managerId = role === USER_ROLES.MANAGER ? (employee?.employee_id ?? -1) : null;

        const response = await getDashboardSummary(null, managerId);

        setDashboard(response);

      }

      catch (error) {

        console.error(
          "Reports Error:",
          error
        );

      }

      finally {

        setLoading(false);

      }

    };


    loadSummary();


  }, [role, employee, roleLoading]);





  if (loading) {


    return (

      <Box

        sx={{

          bgcolor: "background.default",

          minHeight: "100vh",

          p: 3

        }}

      >

        <Skeleton variant="text" width={220} height={40} />

        <Skeleton variant="text" width={320} height={22} sx={{ mb: 3 }} />

        <Box

          sx={{

            display: "grid",

            gridTemplateColumns: {

              xs: "1fr",

              sm: "repeat(2,1fr)",

              md: "repeat(4,1fr)"

            },

            gap: 2,

            mb: 3

          }}

        >

          {Array.from({ length: 8 }).map((_, index) => (

            <Skeleton

              key={`kpi-skeleton-${index}`}

              variant="rounded"

              height={100}

              sx={{ borderRadius: 3 }}

            />

          ))}

        </Box>

        <Box

          sx={{

            display: "grid",

            gridTemplateColumns: {

              xs: "1fr",

              md: "repeat(3,1fr)"

            },

            gap: 2,

            mb: 3

          }}

        >

          {Array.from({ length: 3 }).map((_, index) => (

            <Skeleton

              key={`chart-skeleton-1-${index}`}

              variant="rounded"

              height={330}

              sx={{ borderRadius: 3 }}

            />

          ))}

        </Box>

        <Box

          sx={{

            display: "grid",

            gridTemplateColumns: {

              xs: "1fr",

              md: "repeat(2,1fr)"

            },

            gap: 2

          }}

        >

          {Array.from({ length: 2 }).map((_, index) => (

            <Skeleton

              key={`chart-skeleton-2-${index}`}

              variant="rounded"

              height={330}

              sx={{ borderRadius: 3 }}

            />

          ))}

        </Box>

      </Box>

    );

  }





  if (!dashboard) {

    return null;

  }





  const summary = dashboard.summary;





  const cards = [


    {
      title: "Total Tickets",
      value: summary.total_tickets,
      icon: "🎫"
    },


    {
      title: "Open Tickets",
      value: summary.open_tickets,
      icon: "🔴"
    },


    {
      title: "Assigned Tickets",
      value: summary.assigned_tickets,
      icon: "📋"
    },


    {
      title: "In Progress",
      value: summary.in_progress_tickets,
      icon: "⌛"
    },


    {
      title: "Resolved",
      value: summary.resolved_tickets,
      icon: "✅"
    },


    {
      title: "Closed",
      value: summary.closed_tickets,
      icon: "✔"
    },


    {
      title: "Critical",
      value: summary.critical_tickets,
      icon: "🚨"
    },


    {
      title: "High Priority",
      value: summary.high_priority_tickets,
      icon: "⚠"
    }


  ];





  return (


    <Box

      sx={{

        bgcolor:"background.default",

        minHeight:"100vh",

        p:3

      }}

    >




      {/* HEADER */}


      <Typography

        variant="h4"

        fontWeight={600}

        color="text.primary"

      >

        Reports & Analytics

      </Typography>





      <Typography

        sx={{

          fontSize:13,

          color:"text.secondary",

          mb:3

        }}

      >

        Overview of ticket analytics and service performance

      </Typography>








      {/* KPI CARDS */}


      <Box

        sx={{

          display:"grid",

          gridTemplateColumns:{

            xs:"1fr",

            sm:"repeat(2,1fr)",

            md:"repeat(4,1fr)"

          },

          gap:2,

          mb:3

        }}

      >


        {
          cards.map((card,index)=>(

            <ReportCard

              key={index}

              title={card.title}

              value={card.value}

              icon={card.icon}

            />

          ))
        }


      </Box>








      {/* CHART ROW 1 */}


      <Box

        sx={{

          display:"grid",

          gridTemplateColumns:{

            xs:"1fr",

            md:"repeat(3,1fr)"

          },

          gap:2,

          mb:3

        }}

      >




        <Paper

          sx={{

            height:330,

            p:2,

            borderRadius:3,

            border:"1px solid",

            borderColor:"divider",

            boxShadow:"0 2px 8px rgba(0,0,0,0.04)"

          }}

        >

          <TicketStatusChart />

        </Paper>






        <Paper

          sx={{

            height:330,

            p:2,

            borderRadius:3,

            border:"1px solid",

            borderColor:"divider",

            boxShadow:"0 2px 8px rgba(0,0,0,0.04)"

          }}

        >

          <PriorityChart />

        </Paper>






        <Paper

          sx={{

            height:330,

            p:2,

            borderRadius:3,

            border:"1px solid",

            borderColor:"divider",

            boxShadow:"0 2px 8px rgba(0,0,0,0.04)"

          }}

        >

          <ResolutionTimeChart />

        </Paper>




      </Box>









      {/* CHART ROW 2 */}


      <Box

        sx={{

          display:"grid",

          gridTemplateColumns:{

            xs:"1fr",

            md:"repeat(2,1fr)"

          },

          gap:2,

          mb:3

        }}

      >




        <Paper

          sx={{

            height:330,

            p:2,

            borderRadius:3,

            border:"1px solid",

            borderColor:"divider"

          }}

        >

          <CategoryReport />

        </Paper>






        <Paper

          sx={{

            height:330,

            p:2,

            borderRadius:3,

            border:"1px solid",

            borderColor:"divider"

          }}

        >

          <MonthlyTrendChart />

        </Paper>




      </Box>








      {/* SLA */}


      <Box sx={{mb:3}}>

        <SLAReport />

      </Box>








      {/* RECENT TICKETS */}


      <Box>

        <RecentTickets />

      </Box>




    </Box>


  );


}



export default Reports;